// extracted by mini-css-extract-plugin
export default {"root":"app-portainer-components-form-components-ReactSelect-module__root"};